/* tslint:disable */
/* eslint-disable */
/**
 * Tractable Identity Broker API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RefreshTokenResponse
 */
export interface RefreshTokenResponse {
    /**
     * New access token
     * @type {string}
     * @memberof RefreshTokenResponse
     */
    accessToken: string;
    /**
     * New ID token
     * @type {string}
     * @memberof RefreshTokenResponse
     */
    idToken: string;
    /**
     * 
     * @type {string}
     * @memberof RefreshTokenResponse
     */
    tokenType: string;
    /**
     * Seconds to expiration of the access token
     * @type {number}
     * @memberof RefreshTokenResponse
     */
    expiresIn: number;
}


/**
 * Check if a given object implements the RefreshTokenResponse interface.
 */
export function instanceOfRefreshTokenResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "accessToken" in value;
    isInstance = isInstance && "idToken" in value;
    isInstance = isInstance && "tokenType" in value;
    isInstance = isInstance && "expiresIn" in value;

    return isInstance;
}

export function RefreshTokenResponseFromJSON(json: any): RefreshTokenResponse {
    return RefreshTokenResponseFromJSONTyped(json, false);
}

export function RefreshTokenResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RefreshTokenResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'accessToken': json['accessToken'],
        'idToken': json['idToken'],
        'tokenType': json['tokenType'],
        'expiresIn': json['expiresIn'],
    };
}

export function RefreshTokenResponseToJSON(value?: RefreshTokenResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'accessToken': value.accessToken,
        'idToken': value.idToken,
        'tokenType': value.tokenType,
        'expiresIn': value.expiresIn,
    };
}

